import Axios from "axios";
import { toast } from "react-toastify";
import { decryptResponse } from "../Components/RateCard/utils";
import firebase from "../Firebase/firebase";
import { ENVIRONMENT } from "../config/env.config";

// NOTE: CSP, X-Content-Type-Options, Strict-Transport-Security, and
// X-XSS-Protection are RESPONSE headers — they instruct the browser how
// to treat a page/response it received. Setting them on an outgoing axios

const axios = Axios.create({
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache",
  },
});

// Add the "X-Status" header only if in production
if (ENVIRONMENT === "production") {
  axios.defaults.headers["X-Status"] = "web";
}

axios.interceptors.request.use(async (config) => {
  const token = await firebase.getAccessToken();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // FIX: Normalize double slashes in URL (preserve https://)
  if (config.url) {
    config.url = config.url.replace(/([^:]\/)\/+/g, "$1");
  }

  return config;
});

axios.interceptors.response.use(
  (response) => {
    if (
      response.status === 200 &&
      response.headers["content-type"] === "text/plain"
    ) {
      response.data = decryptResponse(response.data);
    }

    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      firebase.logout();
    } else if (error?.config?.skipErrorToast) {
      return Promise.reject(error);
    } else if (error?.response?.status === 422) {
      toast.error("Permission Denied");
      return Promise.reject(error);
    } else {
      toast.info("Request failed. Please check your connection and retry");
      return Promise.reject(error);
    }
  }
);

export default axios;